<template>
    <div>
        <m-assembly-table ref='pageForm'
            :formData='formData'
            :columns='columns'
            :data='tableData'
            :tableButtons='tableButtons'
            :loading='loading'
            :currentPage='settings.currentPage'
            :pageSize='settings.pageSize'
            :total='settings.total'
            :settings='settings'
            @onSubmit='onSubmit'
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
            @onSelectionChange="onSelectionChange"
        >
        </m-assembly-table>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import {getOuList, queryIntTimeZone, exportExcel} from './financialAccounting';
export default {
    name: 'fpzLiabilitySearch',
    components: { 
        mAssemblyTable 
    },
    data () {
        return {
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'orgId', // 库存组织
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: (val) => {
                                // if (val) {
                                //     getVendorSite(this.orgList.find((item) => item.value === val).erpOrgId, this, (data) => {
                                //         data = [
                                //             {
                                //                 label: 'E01009069001B',
                                //                 value: 'E01009069001B'
                                //             }
                                //         ];
                                //         this.getFormDataItemObj(this.formData.items, 'vendorSiteCode').options.values = data;
                                //     });
                                // }
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('fpzLiabilitySearch.t1'),
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('common.not_empty_require')
                            }
                        }
                    },
                    // {
                    //     value: '',
                    //     field: 'vendorSiteCode', // 供应商地点
                    //     disabled: false,
                    //     layout: {
                    //         span: 8,
                    //         offset: 0,
                    //         row: 1
                    //     },
                    //     methods: {},
                    //     options: {
                    //         multiple: false,
                    //         values: []
                    //     },
                    //     type: 'select',
                    //     title: this.$t('fpzInvaccSearch.t2'),
                    //     validators: {
                    //         required: {
                    //             required: true,
                    //             message: this.$t('common.not_empty_require')
                    //         }
                    //     }
                    // },
                    {
                        value: '',
                        field: 'status', // 状态
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {},
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('fpzInvaccSearch.t3')
                    },
                    // {
                    //     value: '',
                    //     field: 'status', // 审批状态
                    //     disabled: false,
                    //     layout: {
                    //         span: 8,
                    //         offset: 0,
                    //         row: 1
                    //     },
                    //     methods: {},
                    //     options: {
                    //         multiple: false,
                    //         values: []
                    //     },
                    //     type: 'select',
                    //     title: this.$t('fpzLiabilitySearch.t2')
                    // }
                ]
            },
            columns: {
                columns: [
                    {
                        title: this.$t('fpzInvaccSearch.t4'), // 明细
                        align: 'center',
                        minWidth: 40,
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    size: 'small',
                                    icon: 'm-icon m-icon-ios-list-outline'
                                },
                                on: {
                                    click: () => {
                                        let {headerId, orgId} = params.row;
                                        this.$router.push({
                                            name: 'fpzliabilityDetail', 
                                            query: {
                                                headerId, 
                                                orgId
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t5'), // 对账单号
                        align: 'center',
                        minWidth: 110,
                        key: 'liabilityNum'
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t8'), // 对账状态
                        align: 'center',
                        minWidth: 90,
                        key: 'status',
                        render: (h, params) => {
                            let {status} = params.row;
                            return h('span', status && this.INT_RECONCILIATION_STATUS.find((item) => item.value === status).label);
                        }
                    },
                    {
                        title: this.$t('fpzLiabilitySearch.t3'), // 创建日期
                        align: 'center',
                        minWidth: 130,
                        key: 'creationDate',
                        render: (h, params) => {
                            let {creationDate} = params.row;
                            return h('span', creationDate && moment(creationDate).add(this.offsetTime, 'h').format('YYYY-MM-DD HH:mm:ss') || '');
                        }
                    },
                    {
                        title: this.$t('fpzLiabilitySearch.t4'), // 截至日期
                        align: 'center',
                        minWidth: 80,
                        key: 'endDate'
                    },
                    {
                        title: this.$t('fpzLiabilitySearch.t13'),// 汇总数量
                        align: 'right',
                        minWidth: 70,
                        key: 'sumQuantity'
                    },
                    {
                        title: this.$t('fpzLiabilitySearch.t14'),// 拒绝原因
                        align: 'right',
                        minWidth: 200,
                        key: 'description'
                    },
                    // {
                    //     title: this.$t('fpzLiabilitySearch.t5'), // 审核结果
                    //     align: 'center',
                    //     minWidth: 200,
                    //     key: 'description'
                    // },
                    {
                        title: this.$t('fpzInvaccSearch.t10'), // 供应商确认日期
                        align: 'center',
                        minWidth: 140,
                        key: 'supplierDate',
                        render: (h, params) => {
                            let {supplierDate} = params.row;
                            return h('span', supplierDate && moment(supplierDate).add(this.offsetTime, 'h').format('YYYY-MM-DD HH:mm:ss') || '');
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t11'), // 删除
                        align: 'center',
                        key: 'status',
                        minWidth: 60,
                        render: (h, params) => {
                            let {headerId, status} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(status);
                            return h('Button', {
                                props: {
                                    type: 'text',
                                    icon: 'trash-b',
                                    disabled
                                },
                                on: {
                                    click: () => {
                                        this.deleteLine(headerId);
                                    }
                                }
                            });
                        }
                    },
                    // {
                    //     title: this.$t('fpzLiabilitySearch.t6'), // 提交对账单
                    //     align: 'center',
                    //     key: 'PRINT_FLAG',
                    //     minWidth: 60,
                    //     render: (h, params) => {
                    //         return h('Button',
                    //             {
                    //             props: {
                    //                 type: 'text',
                    //                 icon: 'printer'
                    //             },
                    //             on: {
                    //                 click: () => {
                    //                     // this.print(params.row.headerId);
                    //                 }
                    //             }
                    //         });
                    //     }
                    // },
                    {
                        title: this.$t('fpzLiabilitySearch.t7'), // 对账单
                        align: 'center',
                        key: 'PRINT_FLAG',
                        minWidth: 60,
                        render: (h, params) => {
                            return h('Button',
                                {
                                props: {
                                    type: 'text',
                                    icon: 'printer',
                                    loading: this.printLoading
                                },
                                on: {
                                    click: () => {
                                        let {headerId, orgId} = params.row;
                                        this.print(headerId, orgId);
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t18'), // 附件
                        align: 'center',
                        minWidth: 230,
                        render: (h, params) => {
                            let format = ['jpeg', 'jpg', 'png', 'gif', 'pdf', 'rar', 'zip', '7z'];
                            let {headerId, status, accessoryUrl, accessoryName} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(status);
                            let upload = h('Upload', {
                                props: {
                                    action: '/gscint/supplierfile/uploadFile',
                                    format,
                                    showUploadList: false,
                                    onSuccess: (response, file) => {
                                        let {fileName, docId} = response.data;
                                        axios.post('/gscint/hw/liability/uploadFile', {
                                            accessoryName: fileName,
                                            accessoryUrl: docId,
                                            headerId: headerId,
                                            vendorCode: this.vendorCode
                                        }).then(res => {
                                            if (res.data.success) {
                                                this.$Modal.success({
                                                    content: this.$t('fpzInvaccSearch.t19') // 上传成功
                                                });
                                                this.onSubmit();
                                            } else {
                                                this.showErrorTips('loading', res.data.msg);
                                            }
                                        });
                                    },
                                    onFormatError: () => {
                                        this.$Modal.error({
                                            // 附件只支持 xxx 格式
                                            content: `${this.$t('fpzInvaccSearch.t20')}${format.join()}${this.$t('fpzInvaccSearch.t21')}`
                                        });
                                    }
                                }
                            },
                            [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        icon: 'upload',
                                        disabled
                                    }
                                })
                            ]);
                            if (!accessoryUrl) {
                                return upload;
                            } else {
                                return h('div', {}, [
                                    h('a', {
                                        attrs: {
                                            href: `/gscint/supplierfile/downloadFile?docId=${accessoryUrl}`
                                        }
                                    }, [accessoryName]),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            icon: 'close',
                                            disabled
                                        },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    content: this.$t('fpzInvaccSearch.t22'), // 是否删除附件？
                                                    onOk: () => {
                                                        const url = '/gscint/hw/liability/uploadFile';
                                                        axios.post(url, {
                                                            accessoryName,
                                                            accessoryUrl,
                                                            headerId,
                                                            vendorCode: this.vendorCode,
                                                            uploadFlag: 'del'
                                                        })
                                                        .then(res => {
                                                            if (res.data.data.success) {
                                                                setTimeout(() => {
                                                                    this.$Modal.success({
                                                                        content: this.$t('fpzInvaccSearch.t23') // 删除成功
                                                                    });
                                                                }, 500);
                                                                this.onSubmit();
                                                            }
                                                        })
                                                        .catch(() => {
                                                            this.showErrorTips();
                                                        });
                                                    }
                                                });
                                            }
                                        }
                                    })
                                ]);
                            }
                        }
                    },
                    {
                        title: this.$t('fpzInvaccSearch.t24'), // 确认按钮
                        align: 'center',
                        key: 'status',
                        minWidth: 60,
                        render: (h, params) => {
                            let {status, headerId} = params.row;
                            let disabled = !['NEW', 'REJECT'].includes(status);
                            return h('Button',
                                {
                                props: {
                                    type: 'text',
                                    icon: 'checkmark',
                                    disabled,
                                    loading: this.lineLoading
                                },
                                style: {
                                    fontSize: '16px',
                                    color: disabled ? '#bbbec4' : '#2d8cf0'  
                                },
                                on: {
                                    click: () => {
                                        this.confirm(headerId, params.row)
                                        .then(() => {
                                            this.lineLoading = false;
                                        })
                                        .catch(() => {
                                            this.lineLoading = false;
                                        });
                                    }
                                }
                            });
                        }
                    }
                ]
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('fpzInvaccSearch.t26'),
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            this.$router.push({
                                name: 'fpzLiabilityAdd'
                            });
                        }
                    },
                    {
                        label: this.$t('fpzInvaccSearch.t27'),
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                this.$set(button, 'loading', true);
                                exportExcel(button, this, this.getFormDataVModel(this.formData.items), '/gscint/hw/liability/exportHeaders');
                            }
                        }
                    }
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false
            },
            selection: [],
            INT_RECONCILIATION_STATUS: [],
            orgList: [],
            offsetTime: 0,
            printLoading: false,
            lineLoading: false
        }
    },
    methods: {
        confirm(headerId, {accessoryUrl, accessoryName}) {
            if (!accessoryUrl || !accessoryName) {
                this.$Modal.warning({
                    content: this.$t('fpzInvaccCommon.t37')
                })
                return false;
            }
            this.lineLoading = true;
            return axios.post('/gscint/hw/liability/confirm', {
                vendorCode: this.vendorCode,
                headerId
            })
            .then(res => {
                let {code} = res.data.data;
                if (code !== -1) {
                    this.$Modal.success({
                        content: this.$t('fpzInvaccSearch.t25')
                    });
                    this.onSubmit();
                } else {
                    this.showErrorTips();
                }
            })
            .catch(() => {
                this.showErrorTips();
            })
        },
        deleteLine (headerId, from, to) {
            this.$Modal.confirm({
                // 确定要删除对账期间 from 到 to 的对账单吗？
                content: `${this.$t('fpzLiabilityCommon.t4')}`,
                onOk: () => {
                    axios.post('/gscint/hw/liability/delete', {
                        vendorCode: this.vendorCode,
                        headerId
                    }).then(res => {
                        if (res.data.success) {
                            this.onSubmit();
                            setTimeout(() => {
                                this.$Modal.success({
                                    content: this.$t('fpzInvaccSearch.t15')
                                });
                            }, 500);
                        } else {
                            setTimeout(() => {
                                this.showErrorTips('loading', res.data.msg);
                            }, 500);
                        }
                    })
                    .catch(() => {
                        this.showErrorTips();
                    });
                }
            });
        },
        print(headerId, orgId) {
            this.printLoading = true;
            let supplierInfo = JSON.parse(localStorage.getItem('supplierInfo'));
            axios.post('/gscint/hw/liability/queryForPrint', {
                vendorCode: this.vendorCode,
                headerId,
                orgId
            })
            .then((res) => {
                let {data, code, message} = res.data.data;
                if (code === 1) {
                    this.cloudPrint('liabilityCountNew-hw', {reportlets: {
                        printUser: supplierInfo && supplierInfo.userName,
                        ...data
                    }})
                    .then(() => {
                    this.printLoading = false;
                    })
                    .catch(() => {
                        this.printLoading = false;
                    });
                } else {
                    this.showErrorTips('printLoading', message);
                }
            })
            .catch(() => {
                this.showErrorTips('printLoading');
            });
        },
        str2camel(str) {
            str = str.toLowerCase();
            let newStr = '';
            for (let i = 0; i < str.length; i++) {
            if (str[i] === '_') {
                i++;
                if (str[i]) {
                newStr += str[i].toUpperCase();
                }
                continue;
            }
            newStr += str[i];
            }
            return newStr;
        },
        onSubmit () {
            this.loading = true;
            let postData = this.getFormDataVModel(this.formData.items);
            axios.post('/gscint/hw/liability/queryHeaders', {
                ...postData,
                vendorCode: this.vendorCode,
                pageNum: this.settings.currentPage,
                pageSize:  this.settings.pageSize
            })
            .then(res => {
                this.loading = false;
                let {list, total} = res.data.data;
                this.tableData = list;
                this.settings.total = total;
                queryIntTimeZone(postData.orgId, (data) => {
                    this.offsetTime = data;
                });
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSubmit();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSubmit();
        },
        onSelectionChange (selection) {
            this.selection = selection;
        }
    },
    mounted() {
        // this.getUserBaseInfo((res) => {
        //     let {vendorId, vendorCode} = res.data.data;
        //     this.vendorId = vendorId;
        //     this.vendorCode = vendorCode;
        // });
        getOuList((data) => {
            this.getFormDataItemObj(this.formData.items, 'orgId').options.values = data;
        });
        this.getDict('INT_RECONCILIATION_STATUS', (data) => {
            this.getFormDataItemObj(this.formData.items, 'status').options.values = data.filter((item) => item.email !== 'N');
        });
    },
}
</script>